import { useState } from "react";
import { Switch } from "@headlessui/react";
import { classNames } from "../utils";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import ReactTooltip from "react-tooltip";

type Props = {
  label: string;
  onChange?: (value: boolean) => void;
  labelClassName?: string;
  defaultValue?: boolean;
  disabled?: boolean;
  tooltip?: string;
};

export default function Toggle({
  label,
  onChange,
  labelClassName = "",
  defaultValue = false,
  disabled = false,
  tooltip = "",
}: Props) {
  const [enabled, setEnabled] = useState(defaultValue);

  return (
    <div className="inline-flex items-center justify-between mr-2.5 w-full">
      {label && (
        <span
          className={classNames(
            !labelClassName ? "w-56 text-sm font-medium" : labelClassName
          )}
        >
          {label}
          {tooltip && (
            <>
              <InformationCircleIcon
                className="inline-flex w-5"
                data-tip={tooltip}
              />
              <ReactTooltip
                className="hover:visible:opacity-1 w-96"
                delayHide={300}
                effect="solid"
              />
            </>
          )}
        </span>
      )}
      {disabled && (
        <span
          className={classNames(
            "text-sm font-medium",
            enabled ? "text-green-600" : "text-gray-500"
          )}
        >
          {enabled ? "On" : "Off"}
        </span>
      )}

      {!disabled && (
        <Switch
          checked={enabled}
          onChange={(newValue: boolean) => {
            onChange?.(newValue);
            setEnabled(newValue);
          }}
          disabled={disabled}
          className={`${enabled ? "bg-green-600" : "bg-gray-300"}
          relative inline-flex h-[20px] w-[42px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
        >
          <span
            aria-hidden="true"
            className={`${enabled ? "translate-x-5" : "translate-x-0"}
            pointer-events-none inline-block h-[16px] w-[16px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
          />
        </Switch>
      )}
    </div>
  );
}
